<div class="bc-row bc-justify-content-center">
  <div class="bc-col-md-10 bc-col-sm-12 bc-col-xs-6">
      <h6 class="title">
        Selecciona el valor que vas a pagar:
      </h6>
  </div>
</div>

<br>
<form [formGroup]="frmStepTwo">
  <div class="bc-row bc-justify-content-center bc-align-items-center">
    <div class="bc-col-lg-4 bc-col-md-5 bc-col-sm-10 bc-col-xs-5">
      <div class="card" id="card">
        <div class="card-header">
          <div class="bc-row bc-justify-content-center bc-align-self-center">
            <div class="bc-w-auto bc-align-items-center">
              <div class="titulo">Valor a pagar:</div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="bc-row bc-justify-content-center">
            <div class="bc-col-auto">
              <bc-icon size="3xl" name="cash"></bc-icon>
            </div>
          </div>
          <div class="bc-row bc-justify-content-center">
            <div class="bc-col-auto">
              <div class="valor-minimo">{{customer.currentMinimumPayment | currency:"$":"symbol":"1.2-2"}}</div>
              <hr>
            </div>
          </div>
          <div class="bc-row bc-justify-content-center">
            <div class="bc-col-auto">
              <bc-radio-group formControlName="radioMinimun" (change)="changeValue($event)">
                <bc-radio id="pt-min" [enabled]="customer.currentMinimumPayment!=0" value="1">Valor pago mínimo</bc-radio>
              </bc-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bc-col-md-4 bc-col-sm-8 bc-col-xs-5 bc-mt-3">
      <div class="bc-row">
        <div class="bc-col-12">
          <h6 class="titulo2">También puedes seleccionar otro valor a pagar:</h6>
        </div>
      </div>
      <div class="bc-row">
        <div class="bc-col-xs-5 bc-col-sm-12 bc-col-md-11 bc-col-lg-8">
          <bc-radio-group  formControlName="radioPayment" id="radioPayment" (change)="changeValue($event)">
            <bc-radio id="pt-tot" value="2">
              Pago total: {{customer.currentTotalPayment | currency:"$":"symbol":"1.2-2"}}
            </bc-radio>
            <br>
            <bc-radio id="pt-other" value="3">
              Otro valor
            </bc-radio>
          </bc-radio-group>
        </div>
      </div>
      <br>
      <div class="bc-row">
        <div class="bc-col-md-12 bc-col-sm-12">
          <bc-form-field>
            <em>currency-peso</em>
            <input bc-input type="text"
                  state="{{stateOtherValue}}" id="otherValue" name="otherValue"
                  autocomplete="off"
                  formControlName="otherValue"
                  (click)="activateOtherValue()"
                  (keyup)="validateOtherValue($event)"
                  #inputOtherValue
                  onpaste="return false"
                  mask="separator.2" thousandSeparator="," decimalMarker=".">
            <label for="otherValue">Digita el valor que quieres pagar:</label>
            <span *ngIf="showErrorOtherValue">
              * Por favor ingresa un valor que no sea superior al pago total.
            </span>
          </bc-form-field>
        </div>
      </div>
    </div>
  </div>

  <br><br>

  <div class="bc-row bc-justify-content-center" style="height: 35px;">
    <div class="bc-col-md-10 bc-col-sm-11 bc-col-xs-5 col-gray">
      <div class="bc-row bc-justify-content-center bc-align-items-center" style="height: 100%;">
        <div class="bc-w-auto">
          <div class="titulo">Detalles del crédito:</div>
        </div>
      </div>
    </div>
  </div>
  <div class="bc-row bc-justify-content-center bc-mt-3">
    <div class="bc-col-md-3 bc-col-sm-10 bc-col-xs-5">
      <bc-form-field>
        <input bc-input aria-label="input" type="text" id=NumeroCredito value="{{ customer.loanId }}" readonly/>
        <label for="NumeroCredito">Número de crédito:</label>
      </bc-form-field>
    </div>
    <div class="bc-col-md-3 bc-col-sm-10 bc-col-xs-5">
      <bc-form-field>
        <input bc-input aria-label="input" type="text" id=TipoCredito value="{{ customer.productGroupDescription }}" readonly/>
        <label for="TipoCredito">Tipo de crédito:</label>
      </bc-form-field>
    </div>
    <div class="bc-col-md-3 bc-col-sm-10 bc-col-xs-5">
      <bc-form-field >
        <input bc-input type="text" id="FechaLimite" value="{{ dateToPay }}" readonly/>
        <label for="FechaLimite">Fecha límite de pago:</label>
      </bc-form-field>
    </div>
  </div>
</form>

<br><br>

<div class="bc-container">
  <div class="bc-row bc-justify-content-center">
    <div class="bc-col-md-1 bc-col-sm-2 bc-col-xs-1 text-center">
      <bc-icon size="xl" name="info"></bc-icon>
    </div>
    <div class="bc-col-md-9 bc-col-sm-8 bc-col-xs-5">
      <div class="advertisement">
        Si vas a pagar con PSE, ten en cuenta que el horario de servicio solo estará disponible en días hábiles (lunes - viernes) y hasta las 5:00 p.m; los pagos realizados dentro de este horario generalmente se reflejan de inmediato. En caso de realizar el pago después de esa hora, se verá reflejado con la fecha del siguiente día hábil.
        <br>
        Si prefieres usar el botón de Nequi, puedes hacerlo cualquier día de la semana, incluyendo sábados y domingos. Debes tener en cuenta que el pago se verá reflejado en tu crédito al siguiente día hábil.
      </div>
    </div>
  </div>
</div>
<br>
<div class="bc-container">
  <div class="bc-row bc-justify-content-center">
    <div class="bc-col-md-1 bc-col-sm-2 bc-col-xs-1 text-center">
      <bc-icon size="xl" name="info"></bc-icon>
    </div>
    <div class="bc-col-md-9 bc-col-sm-8 bc-col-xs-5">
      <div class="advertisement">
        Si realizas el pago total de tu crédito, ten en cuenta que podrían quedar valores generados y no cobrados pendientes por cancelar. Para llamadas en Bogotá comunícate al  (+57) 601 44 4 6600 y al resto del país a la línea gratuita nacional 01 8000 517 834 para mayor información.
      </div>
    </div>
  </div>
</div>

<br><br>

<bc-modal title=""
          componentId="modalToWompi"
          [typeIcon]="typeIcon"
          customWidth="medium"
          [titleAlign]="titleAlign"
          [isCancellable]="action"
          [subTitle]="subTitle"
          buttonAlignment="{{ buttonAlignment }}"
          textBtn="Sí"
          textBtnLeft="No"
          typeNotify="success"
          (stateClick)="onPressButton($event)"
          [displayButton]="displayButton"
          [outerCloseTap]="outerCloseTap">
  <div modalContent>
    <p class="bc-text-center">
      Estás a punto de abrir una página externa al sitio oficial de Sufi,
      al hacerlo ingresarás a la pasarela de pagos Wompi. ¿Deseas continuar?
    </p>
  </div>
</bc-modal>